module.exports = __webpack_public_path__ + "img/Adeola.519a8b55.jpg";